<template>
  <div
    :class="[
      'flex items-center justify-center',
      {
        'flex-row-reverse': templateIcon?.position === 'right',
        'flex-col lg:flex-row': templateIcon?.stack && (templateIcon?.position === 'left' || !templateIcon?.position),
        'flex-col lg:flex-row-reverse': templateIcon?.stack && templateIcon?.position === 'right',
      },
    ]"
  >
    <m-icon v-if="templateIcon" :icon="templateIcon.icon" :spin="loading" :size="templateIcon.size" />
    <slot />
  </div>
</template>

<script lang="ts" setup>
  /**
   * Container for MButtonIcon
   * @slot default - Content to be placed inside the container
   */
  import { computed } from 'vue';
  import { faSpinner } from '@fortawesome/free-solid-svg-icons';
  import MIcon from '../MIcon/MIcon.vue';
  import type { MButtonProps, MButtonIconProps } from '.';
  import { isMIconProp } from '.';

  const props = withDefaults(defineProps<MButtonProps>(), {
    loading: false,
    icon: undefined,
  });

  const templateIcon = computed<MButtonIconProps | undefined>(() => {
    if (props.loading) return loadingIcon.value;
    else if (props.icon === undefined || !isMIconProp(props.icon)) return props.icon;
    return {
      icon: props.icon,
      position: 'left',
    };
  });

  const loadingIcon = computed<MButtonIconProps>(() => {
    return {
      icon: faSpinner,
      size: !isMIconProp(props.icon) ? props.icon?.size : undefined,
    };
  });
</script>
